import { render, staticRenderFns } from "./About.vue?vue&type=template&id=c9d421c8&scoped=true&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"
import style0 from "./About.vue?vue&type=style&index=0&id=c9d421c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d421c8",
  null
  
)

/* custom blocks */
import block0 from "./About.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseRichtext: require('/app/components/base/Richtext.vue').default,BaseBtn: require('/app/components/base/Btn.vue').default})
